import { FilterOption } from "@/composables/Bestandsaufnahme/useBestandsaufnahmens";
import { SortTermActive } from "@/composables/Sort/SortTerms";
import { DateFilters } from "@/store/store.types";
import { getDateQuery } from "@/utilities/query-helper";
import QueryString from "qs";

interface BaFilterInput {
    searchString?: string;
    stateFilters: FilterOption[];
    dateFilter?: DateFilters;
}
interface BaQueryInput {
    page: number;
    pageSize: number | void;
    sortBy?: SortTermActive;
    searchString?: string;
    stateFilters: FilterOption[];
    dateFilter?: DateFilters;
}

export const getBaFilters = ({
    searchString,
    stateFilters,
    dateFilter
}: BaFilterInput) => {
    let filters: any = null;

    if ((searchString ?? "") != "") {
        filters = {
            $and: [
                {
                    $or: [
                        { immobilie: { name: { $containsi: searchString, } } },
                        { immobilie: { eigentuemer: { $containsi: searchString } } },
                        { immobilie: { strasse: { $containsi: searchString } } },
                        { immobilie: { plz: { $containsi: searchString } } },
                        { immobilie: { stadt: { $containsi: searchString } } },
                        { immobilie: { externeObjektNr: { $containsi: searchString } } },
                        { immobilie: { baujahr: { $containsi: searchString } } },
                    ]
                }
            ]
        };
    }

    if (!filters) { filters = { $and: [] }; }

    if (dateFilter) {
        dateFilter.forEach((filter) => {
            const { start, end } = getDateQuery(filter.value);
            filters.$and.push({ [filter.option]: start });
            filters.$and.push({ [filter.option]: end });
        });

    }

    const backendFilter = stateFilters.filter((el: FilterOption) => !el.id.startsWith('LOCALE'));
    if (backendFilter && stateFilters.length > 0) {
        const stateQuery: any = { $or: [] };
        backendFilter.forEach((el: FilterOption) => {
            stateQuery.$or.push({ status: el.id });
        });
        filters.$and.push(stateQuery);
    } else {
        filters.$and.push({ status: { $ne: 'ARCHIVIERT' } });
    }

    if (filters.$and.length === 0) {
        return null;
    }
    return filters;
};


export const getBaQuery = async ({
    page,
    pageSize,
    sortBy,
    searchString,
    stateFilters,
    dateFilter
}: BaQueryInput) => {

    const query: any = {};

    if (pageSize) {
        query.pagination = {
            page: page,
            pageSize: pageSize
        };
    }

    if (sortBy) {
        let sortObj: any;
        if (sortBy.fieldName === "malusColor") {
            sortObj = [[sortBy.fieldName] + ":" + sortBy.orderBy, "malus:" + sortBy.orderBy];
        } else {
            sortObj = { [sortBy.fieldName]: sortBy.orderBy };
        }
        if (sortBy.subObject) {
            query.sort = { [sortBy.subObject]: sortObj };
        } else {
            query.sort = sortObj;
        }
    }

    const filters = getBaFilters({
        searchString,
        stateFilters,
        dateFilter
    });

    if (filters) {
        query.filters = filters;
    }

    return QueryString.stringify(query);
};